import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "9c3578f1-6ff2-4278-a9de-5f5fb6ce39c4",
  publicId: "29",
  name: "Perceptual evaluation of noise",
  difficulty: 1,
  contentTypes: { audio: false, interactive: false, video: true },
  body: [principle01, principle02, task01],
};

export default lesson;
